import { SVGIconComponent } from './types';

export const HubTypeKiosklessSpacesHub: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color, ...style }}
    className={className}
  >
    <path
      fill="currentColor"
      d="M8.29 1a.19.19 0 0 1 .193.192l-.001 2.519h1.035V1.192A.19.19 0 0 1 9.71 1h4.012a.19.19 0 0 1 .194.192l-.001 2.519h1.513V2.292c0-.43.353-.78.786-.78s.786.35.786.78v15.52c0 .086-.059.16-.141.181l-.052.007h-1.184a.19.19 0 0 1-.193-.192l-.001-2.009H2.571v2.013c0 .086-.059.16-.141.181L2.378 18H1.194A.19.19 0 0 1 1 17.808V2.292c0-.43.352-.78.786-.78.433 0 .785.35.785.78v1.419h1.514l-.001-2.519A.19.19 0 0 1 4.277 1zm7.139 9.534H2.571v3.704h1.514v-2.52a.19.19 0 0 1 .194-.191H8.29a.19.19 0 0 1 .193.192l-.001 2.519h1.035v-2.52a.19.19 0 0 1 .194-.191h4.012a.19.19 0 0 1 .193.192l-.001 2.519h1.513zm-.001-5.262H2.571v3.705h.575v-2.57a.19.19 0 0 1 .194-.191h3.23a.19.19 0 0 1 .193.192v2.569h.382v-2.57a.19.19 0 0 1 .194-.191h3.231a.19.19 0 0 1 .193.192v2.569h.382v-2.57a.19.19 0 0 1 .194-.191h3.231a.19.19 0 0 1 .193.192v2.569h.664z"
    />
  </svg>
);
